<!-- <app-barra-consulta-mensal *ngIf="!carregando" visible="false" (inserindo)="novo($event)"
  (definirFiltro)="definirFiltragem()" [exibirNovo]="false" (voltando)="voltar()" [exibirBotaoDefinirFiltros]="false"
  [exibirBotaoBuscar]="false">
</app-barra-consulta-mensal> -->

<div class="conteudo ml-2 mr-2">
  <!-- <div class="filtro-dash filtro-dealer shadow-sm">
    <div class="ml-2">
      <div translate class="filtro ng-star-inserted sm-font" style="margin: 10px 22px 0px 0px;">
        {{'businessIntelligence.registro1Servico.dealers'}}
      </div>
      <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtroDealers.selecionados()"
        style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
        {{dealer.nome}}
        <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
      </span>
      <div class="botao">
        <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
          <em class="fa fa-plus"></em>
        </button>
      </div>
      <div class="clear"></div>
    </div>
  </div> -->
  <!-- <div class="row">
    <div class="col-8">
      <app-amp-detalhado-detalhado-filtro [filtros]="filtros"></app-amp-detalhado-detalhado-filtro>
    </div>
    <div class="col-4">
      <button translate class="btn btn-primary ml-2 mt-4" type="button" (click)="pesquisar()">
        {{'businessIntelligence.registro1Servico.filtrar'}}
        <em class="fa fa-search"></em>
      </button>
    </div>
  </div> -->
  <app-amp-detalhado-detalhado-lista (exibir)="selecionar($event)" [carregar]="filtrar()">
  </app-amp-detalhado-detalhado-lista>
  <app-selecionar [idModal]="'modal-dealers'" [titulo]="modalTexto" [lista]="filtroDealers.naoSelecionados()"
    (escolhido)="onAdicionarDealerFiltro($event)">
  </app-selecionar>
</div>